// extracted by mini-css-extract-plugin
export default {"promowrap":"HM","promo":"IM","ship":"JM","pause":"KM","happy":"LM","promotext":"MM"};
    if(module.hot) {
      // 1713912567093
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  